import React__default from 'react';
import img from '../images/tooltip.png.esm.js';

var TooltipImage = function TooltipImage(props) {
  var tooltipText = props.tooltipText;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "group flex"
  }, /*#__PURE__*/React__default.createElement("img", {
    src: img,
    className: "size-[22px] cursor-pointer"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "csg-tw- invisible absolute -translate-x-5 -translate-y-28 border transition-opacity group-hover:visible"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "mx-[26px] my-6 max-w-md"
  }, tooltipText, /*#__PURE__*/React__default.createElement("div", {
    className: "csg-tw- absolute size-4 -translate-x-1 translate-y-4 rotate-45 border-b border-r"
  }))));
};

export { TooltipImage };
//# sourceMappingURL=tooltip-image.esm.js.map
